export const getAboutData = state => state?.about?.data || null
